
<template>
  <div class="account-creation d-flex flex-column">
    <div class="account-creation--header bg-white-custom d-flex align-items-center justify-content-center">
      <div class="d-flex align-items-center">
        <img src="/images/rcl-logo-badge-50.png" alt="homepage" />
        <img src="/images/Convey911_logo_text-145x25.png" alt="homepage" />
      </div>
    </div>
    <div class="account-creation--body d-flex flex-column align-items-center p-3">
      <b-row>
        <b-col cols="12">
          <h4 class="text-center mt-3 mb-3">{{`Create account on ${currentUser.agency_name}`}}</h4>
        </b-col>
        <b-col cols="12">
          <b-form-group
            id="fieldset-1"
            label="First name:"
            style="font-weight:500"
            label-for="input-fname"
          >
            <b-form-input
              id="input-fname"
              trim
              v-model="currentUser['fname']"
              :disabled="creatingAccount || responseCode === 409"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            id="fieldset-2"
            label="Last name:"
            style="font-weight:500"
            label-for="input-lname"
          >
            <b-form-input
              id="input-lname"
              trim
              v-model="currentUser['lname']"
              :disabled="creatingAccount || responseCode === 409"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            id="fieldset-3"
            label="Email Address:"
            label-for="input-email"
            style="font-weight:500"
          >
            <b-form-input
              id="input-email"
              trim
              :value="currentUser['email']"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <div class="d-flex align-items-center flex-wrap" style="gap: 16px">
            <b-overlay
              :show="creatingAccount"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="info"
              class="d-inline-block"
            >
              <b-button
                pill
                ref="createAccountButton"
                variant="info"
                :disabled="creatingAccount || setPasswordUrl || responseCode === 409"
                @click="createAccount"
              >
                Set up account
              </b-button>
            </b-overlay>
            <b-button
              pill
              variant="primary"
              @click="goRapidSosLoginPage"
              class="rapidSoSlogin-btn"
            >
              Continue with RapidSOS
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="creatingAccount || feedMsg" class="account-creation--body-status mt-3">
        <b-col cols="12">
          <span v-if="creatingAccount" class="text-dark">Creating account ...</span>
          <template v-else-if="feedMsg">
            <span v-if="responseCode === 201">{{ feedMsg }}</span>
            <span v-else-if="responseCode === 409">
              A user account already exists under that email. Click <a @click="redirectToHost" herf="#" class="text-info" style="cursor: pointer;">here</a> to log into your account
            </span>
            <span v-else class="text-danger">
              {{ feedMsg }}
            </span>
          </template>
        </b-col>
      </b-row>
    </div>
    <AccountLoginModal
      :showModal="showLoginPopup"
      @closeModal="closeLoginPopup"
      @onRapidSosLoginPage="goRapidSosLoginPage"
    />
  </div>
</template>

<script>
import AccountLoginModal from "./AccountLoginModal.vue";

export default {
  name: "AccountCreation",
  props: {
    magicToken: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      creatingAccount: false,
      feedMsg: "",
      responseCode: 0,
      currentUser: null,
      setPasswordUrl: null,
      showLoginPopup: true
    };
  },
  async created() {
    this.feedMsg = "";
    this.responseCode = 0;
    this.currentUser = {...this.magicToken.token_data};
    if (this.currentUser && !!this.currentUser.user_id) {
      this.handleExistingAccount();
    }
  },
  methods: {
    closeLoginPopup() {
      this.showLoginPopup = false;
    },
    redirectToHost() {
      window.location.href = window.location.origin;
    },
    handleExistingAccount() {
      this.responseCode = 409;
      this.feedMsg = "The user account already exists";
      // this.redirectToHost();
    },
    createAccount() {
      this.feedMsg = "";
      this.responseCode = 0;
      this.creatingAccount = true;
      const { fname, lname, email } = this.currentUser;
      const payload = { fname, lname, email };
      this.$ConveyApi.usersApi.createUser({ payload })
        .then(res => {
          const { set_password_url } = res.data.data;
          this.creatingAccount = false;
          this.responseCode = 201;
          if (set_password_url) {
            this.setPasswordUrl = set_password_url;
            this.feedMsg = "Account created.";
            window.location.href = set_password_url;
          } else {
            this.feedMsg = "Account created, please check your email for verification.";
          }
        })
        .catch((err) => {
          this.creatingAccount = false;
          this.responseCode = err.response.status;
          if (err.response.status === 409) {
            this.handleExistingAccount();
          } else if (err.response.status === 401) {
            this.feedMsg = "Token has expired, please contact your agency administrator.";
          } else {
            this.feedMsg = "Creating account went wrong! Please try again.";
          }
        });
    },
    goRapidSosLoginPage() {
      window.location.href = `https://${process.env.VUE_APP_AUTH0_DOMAIN}/authorize?response_type=code&client_id=${process.env.VUE_APP_AUTH0_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_AUTH0_REDIRECT_URI}&connection=RapidSOS`;
    },
  },
  components: {
    AccountLoginModal
  }
};
</script>

<style lang="scss">
.account-creation {
  width: 100%;
  height: 100vh;

  &--header {
    width: 100%;
    height: 70px;
    box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.05);
    @media screen and (max-width: 767px) {
      height: 60px;
    }
  }

  &--logo {
    height: 100%;
  }

  &--body {
    width: 100%;
    height: calc(100vh - 70px);
    overflow-y: auto;

    > div {
      width: 100%;
      max-width: 680px;
    }

    @media screen and (max-width: 767px) {
      height: calc(100vh - 60px);
    }
  }
  & .rapidSoSlogin-btn {
    background: #003377;
    border-color: #0b4da5;
  }
}
</style>